import React, { useContext, useEffect } from 'react'
import { Form, Checkbox } from 'antd'
import { ProjectsContext } from 'views/UserManagement/Projects'

const InProjectToggle = ({ record }) => {
  const { form, formKeys } = useContext(ProjectsContext)
  const { id, in_project, is_account_admin } = record
  let formKey = `${formKeys.PROJECT_USERS_IN_PROJECT}/${id}`

  return (
    <Form.Item style={{ margin: 0 }} key={formKey}>
      {form.getFieldDecorator(formKey, {
        preserve: true,
        initialValue: is_account_admin || in_project,
        valuePropName: 'checked'
      })(<Checkbox disabled={is_account_admin} />)}
    </Form.Item>
  )
}

export default InProjectToggle
